<template>
  <v-container fluid>
    <v-card flat>
      <v-card-text>
        <v-row>
          <h3><v-icon color="success">mdi-access-point-check</v-icon>&nbsp;My Live Applications</h3>
          <v-spacer/>
          <v-btn @click="dialog=!dialog" class="primary" ><v-icon>mdi-plus</v-icon>Create a New Application</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat class="mt-4">
      <v-divider/>
      <v-card-text v-if="applications && applications.length===0">
        You do not have any production applications at the moment!
      </v-card-text>
      <v-card-text v-else>
        <v-data-table
            :headers="headers"
            :items="applications"
        >
          <template v-slot:item.id="{index}">
            <span>{{index+1}}</span>
          </template>
          <!--start date-->
          <template v-slot:item.date_created="{item}">
            <span>{{helpers().formatDate(item.date_created) || 'N/A'}}</span>
          </template>
          <!--end date-->
          <!--start merchant-->
         <!--start merchant-->
          <template v-slot:item.merchant="{ item }">
            <span>{{ item.merchant.name }}</span>
          </template>
          <!--end merchant-->

          <!--end merchant-->
          <!--start scope-->
          <template v-slot:item.scope="{item}">
            <span>{{item.scope.name}}</span>
          </template>
          <!--end scope-->
          <!--start name-->
          <template v-slot:item.name="{item}">
            <span>{{item.application.name}}</span>
          </template>
          <!--end name-->
          <!--start name-->
          <template v-slot:item.client_type="{item}">
            <span>{{item.application.client_type}}</span>
          </template>
          <!--end name-->
          <!--start action-->
          <template v-slot:item.action="{item}">
            <v-btn @click="showCredentials(item)"  class="red accent-1" small>Show Credentials</v-btn>
          </template>
          <!--end action-->
        </v-data-table>
      </v-card-text>
    </v-card>
    <!--START Create APP-->
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Production Application</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form  v-model="isValid" ref="sandboxForm">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        label="Application Name*"
                        required
                        v-model="formData.app_name"
                        :rules="[rules.app_name.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                        label="Merchant Code*"
                        v-model="formData.account_number"
                        required
                        :rules="[rules.account_number.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                        label="Callback URL*"
                        required
                        v-model="formData.callback_url"
                        class="mb-3"
                        :rules="[rules.callback_url.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                      md="12"
                  >
                    <v-select
                        :items="scopes"
                        v-model="formData.scope"
                        label="Select the service would you like to subscribe to*"
                        required
                        :item-text="item=>item.name"
                        :item-value="item=>item.name"
                        @copy.prevent
                        @paste.prevent
                        :rules="[rules.scope.required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" v-if="goLive">
                    <v-text-field
                        label="Enter OTP"
                        required
                        v-model="formData.otp"
                        class="mb-3"
                        :rules="[rules.otp.required]"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" v-if="goLive">
                    <v-file-input
                        label="Upload Test Cases"
                        required
                        @change="onTestCaseUpload"
                        class="mb-3"
                        :rules="[rules.callback_url.required]"
                    ></v-file-input>
                  </v-col> -->
                </v-row>
              </v-form>
            </v-container>
            <small class="error--text">* indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
            >
              Close
            </v-btn>
            <v-btn
                color="primary"
                @click="goLive ? confirm() : save()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--END Create APP-->
    <!--BEGIN Show credentials-->
    <div class="text-center" v-if="Object.keys(appDetails).length>0">
      <v-dialog
          v-model="credentialsDialog"
          width="500"
      >

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            {{ appDetails && appDetails.application.name }}
          </v-card-title>

          <v-card-text class="mt-5">
            <v-text-field
                label="Client ID"
                outlined
                title="Double Click to copy"
                :value="appDetails.application.client_id"
            />
            <v-text-field
                label="Client Secret"
                outlined
                title="Double Click to copy"
                :value="appDetails.application.client_secret"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                outlined
                @click="credentialsDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!--END Show credentials-->
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import helpers from "../../../../shared/utilities/helpers";
import {EventBus} from "../../../../shared/utilities/event-bus";

export default {
  name: "DashboardCardProduction",
  beforeRouteEnter(to,from,next){
    next(v=>{
      v.$store.dispatch("Dashboard/getApplications",{isLive:true})
      v.$store.dispatch("Dashboard/getScopes")
    })
  },
  data: () => ({
    show: false,
    dialog: false,
    isValid:false,
    //
    goLive:false,
    credentialsDialog: false,
    appDetails: {},
    formData: {
      environment:"PRODUCTION",
      app_name:"",
      account_number:"",
      scope:"",
      callback_url:"",
      otp:"",
      // test_case_results_doc:""
    },
    rules: {
      app_name: {
        required: (value) => !!value || 'Application name is Required.',
      },
      scope: {
        required: (value) => !!value || 'Scope is required.',
      },
      callback_url: {
        required: (value) => !!value || 'Callback URL is required.',
      },
      account_number: {
        required: (value) => !!value || 'Merchant code is required.',
      },
      otp: {
        required: (value) => !!value || 'OTP is required.',
      },
      // test_case_results_doc: {
      //   required: (value) => !!value || 'Test case results are required.',
      // },
    },
    headers: [
      {
        text: '#S/N',
        align: '',
        sortable: true,
        value: 'id'
      },
      {
        text: 'Created On',
        align: '',
        sortable: true,
        value: 'date_created'
      },
      {
        text: 'Merchant',
        align: '',
        sortable: true,
        value: 'merchant'
      },
      {
        text: 'Account Number',
        align: '',
        sortable: true,
        value: 'account_number'
      },
      {
        text: 'Scope',
        align: '',
        sortable: true,
        value: 'scope'
      },
      {
        text: 'Name',
        align: '',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Client Type',
        align: '',
        sortable: true,
        value: 'client_type'
      },
      {
        text: 'Actions',
        align: '',
        sortable: true,
        value: 'action'
      },
    ],
  }),
  mounted(){
    EventBus.$on("goLive",val=>{
      this.goLive=val
    })
  },
  computed:{
    applications(){
      return this.$store.getters['Dashboard/DashboardGetter']("applications")
    },
    scopes(){
      return this.$store.getters['Dashboard/DashboardGetter']("scopes")
    },
  },
  methods:{
    helpers() {
      return helpers
    },
    // onTestCaseUpload(file) {
    //   this.formData.test_case_results_doc=file
    // },
    ...mapActions({
      save: function (dispatch) {
        if (!this.isValid) {
          this.$refs.sandboxForm.validate()
          this.submitting = false;
        } else {
          dispatch('Dashboard/createApplications', {...this.formData})
        }
      },
      confirm: function (dispatch) {
        if (!this.isValid) {
          this.$refs.sandboxForm.validate()
          this.submitting = false;
        } else {
          const formData = new FormData();
          // formData.append('test_case_results_doc',this.formData.test_case_results_doc)
          formData.append('environment',this.formData.environment)
          formData.append('app_name',this.formData.app_name)
          formData.append('account_number',this.formData.account_number)
          formData.append('scope',this.formData.scope)
          formData.append('callback_url',this.formData.callback_url)
          formData.append('otp',this.formData.otp)
          // formData.append('test_case_results_doc',this.formData.test_case_results_doc)
          //
          dispatch('Dashboard/confirmApplication', formData)
        }
      },
    }),
    showCredentials(item) {
      this.credentialsDialog=!this.credentialsDialog
      this.appDetails=item
    }
  }
}
</script>
